import { useEffect } from 'react'
import { useWindowSize } from 'usehooks-ts'

import { useScreenWidthChanged } from 'stores/useScreenSizeStore'

import type { FC } from 'react'

export const ScreenSizeUpdater: FC = () => {
  const { width } = useWindowSize({ debounceDelay: 100 })

  const onScreenWidthChanged = useScreenWidthChanged()

  useEffect(() => onScreenWidthChanged(width), [onScreenWidthChanged, width])

  return null
}
